module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-152x152-435cc96e3df6a13c8533e64c57fe514d.png";